export const tokenUrl = "https://us1.pusherplatform.io/services/chatkit_token_provider/v1/5526fd62-fe46-429a-a138-79bac026c3ff/token";

export const instanceLocator = "v1:us1:5526fd62-fe46-429a-a138-79bac026c3ff";
